import React from 'react';

const Contact = () => {
  return (
    <section id="contact">
      <div className="wrap">
        <div className="eyebrow"><span className="prompt">$</span> ping idima --talk</div>
        <h2 className="section-title">Get in touch</h2>
        <p className="section-sub">Open to backend roles, freelance API work, or just a conversation about the stuff I'm building.</p>

        <div className="contact-grid reveal-stagger">
          <div className="contact-card">
            <div className="ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M4 4h16v16H4z" opacity="0" />
                <path d="M3 5h18v14H3V5Zm0 0 9 7 9-7" />
              </svg>
            </div>
            <h4>Email</h4>
            <p>feranmiidima82@gmail.com</p>
            <a className="cta" href="mailto:feranmiidima82@gmail.com">Send a mail →</a>
          </div>

          <div className="contact-card">
            <div className="ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.86 19.86 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.81.3 1.6.54 2.37a2 2 0 0 1-.45 2.11L8.09 9.32a16 16 0 0 0 6 6l1.12-1.11a2 2 0 0 1 2.11-.45c.77.24 1.56.42 2.37.54A2 2 0 0 1 22 16.92Z" />
              </svg>
            </div>
            <h4>WhatsApp</h4>
            <p>+234 703 834 6898</p>
            <a className="cta" href="https://wa.me/2347038346898" target="_blank" rel="noopener noreferrer">Send a DM →</a>
          </div>

          <div className="contact-card">
            <div className="ico">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.8 0 0 .78 0 1.75v20.5C0 23.22.8 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.75V1.75C24 .78 23.2 0 22.22 0Z" />
              </svg>
            </div>
            <h4>LinkedIn</h4>
            <p>oluwaferanmi-idima</p>
            <a className="cta" href="https://www.linkedin.com/in/oluwaferanmi-idima-3967951b2" target="_blank" rel="noopener noreferrer">View profile →</a>
          </div>

          <div className="contact-card">
            <div className="ico">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.21 11.39.6.11.82-.26.82-.58 0-.29-.01-1.04-.02-2.04-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.75.08-.73.08-.73 1.21.08 1.84 1.24 1.84 1.24 1.07 1.84 2.81 1.3 3.49.99.11-.78.42-1.3.76-1.6-2.67-.3-5.47-1.34-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.12-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.6-2.81 5.63-5.48 5.93.43.37.81 1.1.81 2.22 0 1.6-.01 2.89-.01 3.29 0 .32.22.7.83.58A12 12 0 0 0 24 12c0-6.63-5.37-12-12-12Z" />
              </svg>
            </div>
            <h4>GitHub</h4>
            <p>github.com/Hck3r1</p>
            <a className="cta" href="https://github.com/Hck3r1" target="_blank" rel="noopener noreferrer">View profile →</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;